import React from 'react';
import { AnalyticsAlertResponse } from '@/components/dsr-analytics/types';
import { AnalyticsAlertStatusType } from '@/types';
import { AnalyticsAlertWithActionSheet } from '@/components/dsr-analytics/analytics-alert-with-action-sheet';
import { StyleSheet, View } from 'react-native';

interface AnalyticsAlertsProps {
  alerts: Partial<Record<string, AnalyticsAlertResponse>>;
  onAction: (
    alert: AnalyticsAlertResponse,
    actionType: AnalyticsAlertStatusType,
  ) => void;
  onSupportInfoPress?: (alert: AnalyticsAlertResponse) => void;
}

export const AnalyticsAlerts: React.FC<AnalyticsAlertsProps> = ({
  onAction,
  alerts,
  onSupportInfoPress,
}) => (
  <View style={styles.base}>
    {Object.entries(alerts).map(([alertUUID, alertResponse]) => (
      <AnalyticsAlertWithActionSheet
        alert={alertResponse!}
        key={alertUUID}
        onAction={onAction}
        onSupportInfoPress={onSupportInfoPress}
      />
    ))}
  </View>
);

const styles = StyleSheet.create({
  base: {
    flexDirection: 'column',
    gap: 8,
    paddingVertical: 16,
  },
});
